export const localesDictionary = [
    {code: 'es-ES', lang: 'Spanish'},
    {code: 'ca-ES', lang: 'Catalan'},
    {code: 'en-US', lang: 'English'},
    {code: 'it-IT', lang: 'Italian'},
    {code: 'fr-FR', lang: 'French'}
];

// http://www.lingoes.net/en/translator/langcode.htm